import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

const StockMovementReportPrint = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [listOfRecords, setListOfRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const urlParams = new URLSearchParams(window.location.search);
  const startDate = urlParams.get("startDate") || "";
  const endDate = urlParams.get("endDate") || "";
  const registerType = urlParams.get("registerType") || "";
  const movementType = urlParams.get("movementType") || "";
  const itemId = urlParams.get("itemId") || "";

  const reportTitle = () => {
    const from = startDate
      ? moment(startDate).format("DD/MM/YYYY")
      : "-";
    const to = endDate ? moment(endDate).format("DD/MM/YYYY") : "-";
    let title = `Stock Movement Report (${from} to ${to})`;
    if (movementType) {
      title += ` | Movement: ${movementType}`;
    }
    if (registerType) {
      title += ` | Register: ${registerType}`;
    }
    if (itemId) {
      title += ` | Item ID: ${itemId}`;
    }
    return title;
  };

  useEffect(() => {
    document.title = "Print Stock Movement Report";
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 100000,
      StartDate: startDate,
      EndDate: endDate,
      Register_Type: registerType,
      MovementType: movementType,
      ID: parseInt(itemId, 10) || 0,
    };

    axios({
      method: "post",
      url: config.base_url + "Stock/GetStockMovementReport",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setListOfRecords(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setListOfRecords([]);
          setTotalRecords(0);
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        setListOfRecords([]);
      });
  }, []);

  const renderRows = () => {
    if (listOfRecords != null && listOfRecords.length > 0) {
      let count = 1;
      return listOfRecords.map((item, index) => (
        <tr key={index}>
          <td>{count++}</td>
          <td>{item.Dated ? moment(item.Dated).format("DD/MM/YYYY") : ""}</td>
          <td>{item.Stock_Code}</td>
          <td>{item.Item_Name}</td>
          <td>{item.Register_Type}</td>
          <td>{item.MovementType}</td>
          <td>{item.Item_In > 0 ? item.Item_In : "-"}</td>
          <td>{item.Item_Out > 0 ? item.Item_Out : "-"}</td>
          <td>{item.Item_Balance}</td>
          <td>{item.Custodian}</td>
          <td>{item.Description}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="11">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No movements found for the selected filters.
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <Page orientation="landscape" size="a4">
        <table className="table table-sm table-bordered table-print white-space-wrap">
          <thead>
            <tr>
              <th colSpan={11}>
                <PrintHeader title={reportTitle()} />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Sr.</th>
              <th>Date</th>
              <th>Code</th>
              <th>Item</th>
              <th>Register</th>
              <th>Type</th>
              <th>IN</th>
              <th>OUT</th>
              <th>Balance</th>
              <th>Custodian</th>
              <th>Description</th>
            </tr>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="11">
                  <Spinner animation="border" role="status" />
                </td>
              </tr>
            ) : (
              <>
                {renderRows()}
                <tr>
                  <th colSpan={11} className="text-end">
                    Total records: {totalRecords}
                  </th>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default StockMovementReportPrint;
